import Button from '@eduzz/houston-ui/Button';
import Typography from '@eduzz/houston-ui/Typography';
import React from 'react';

import { useStyles } from './styles';

type Props = {
  onRetry: any;
};

export default function Error({ onRetry }: Props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography>Algo inesperado aconteceu.</Typography>
      <Button className={classes.retryButton} onClick={onRetry}>
        Tente novamente
      </Button>
    </div>
  );
}
